import React from "react";
import {
  ButtonBase,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  CardContent,
  Card,
  LinearProgress,
} from "@material-ui/core";
import Download from "@material-ui/icons/CloudDownload";
import { CloudUpload } from "@material-ui/icons";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
// import CardContent from '@mui/material/CardContent';

function niceBytes(x) {
  let l = 0,
    n = parseInt(x, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0);
}
const ActivitiesTabPanel = ({ panelHeight }) => {
  const { downloadKb, uploadKb, measurmentText, progressinternetSpeed } =
    useMeetingAppContext();
  return (
    <List style={{ padding: 10 }}>
      <p style={{ color: "white" }}>
        {" "}
        Below is the bandwidth used by this video call
      </p>
      <Card variant="outlined">
        <CardContent>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Download />
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                textAlign: "center",
                marginLeft: 10,
              }}
            >
              Download data rate
            </div>
          </div>
          <div
            style={{
              fontSize: 25,
              fontWeight: "bold",
              textAlign: "center",
              marginLeft: 10,
            }}
          >
            {niceBytes(Number(downloadKb))} MB/s
          </div>
        </CardContent>
      </Card>
      <Card style={{ marginTop: 10 }} variant="outlined">
        <CardContent>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloudUpload />
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                textAlign: "center",
                marginLeft: 10,
              }}
            >
              Upload data rate
            </div>
          </div>
          <div
            style={{
              fontSize: 25,
              fontWeight: "bold",
              textAlign: "center",
              marginLeft: 10,
            }}
          >
            {niceBytes(Number(uploadKb))} MB/s
          </div>
        </CardContent>
      </Card>
      <LinearProgress
        style={{ marginTop: 10 }}
        variant="determinate"
        value={progressinternetSpeed}
      />

      <div
        style={{
          fontSize: 18,
          fontWeight: "bold",

          color: "white",
          marginTop: 10,
        }}
      >
        Packet loss :
      </div>
      <p style={{ color: "white", fontSize: 15, fontWeight: "600" }}>
        {measurmentText === "" ? "Loading..." : measurmentText}
      </p>
      {/* {[
        {
          Icon: PollIcon,
          primary: "Create Poll",
          secondary:
            "Ask participants their opinion on a subject - Coming Soon.",
          disabled: true,
          onClick: () => {},
        },
        {
          Icon: GestureIcon,
          primary: "White board",
          secondary: "White board - Coming Soon.",
          disabled: true,
          onClick: () => {},
        },
      ].map(({ Icon, primary, secondary, disabled, onClick }, i) => (
        <ButtonBase
          disabled={disabled}
          onClick={onClick}
          style={{
            alignItems: undefined,
            justifyContent: undefined,
            width: "100%",
          }}
        >
          <ListItem key={`activities_panel_item_${i}`}>
            <ListItemAvatar>
              <Avatar>
                <Icon color={"primary"} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primary} secondary={secondary} />
          </ListItem>
        </ButtonBase>
      ))} */}
    </List>
  );
};

export default ActivitiesTabPanel;
